import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GetUsers {
    users {
      email
      enabled
      status
      accounts {
        id
        name
        portfolioCodes
      }
      modifiedDt
      createdDt
      portal
      portfolioCodes
      permissions {
        pledging
        pledgeAndRelease
        apm
        files
        cds
        muniCredit
        houstonTrust
      }
    }
  }
`;
